import { render, staticRenderFns } from "./CustomBarChartQuizType.vue?vue&type=template&id=465a8714&scoped=true"
import script from "./CustomBarChartQuizType.vue?vue&type=script&lang=js"
export * from "./CustomBarChartQuizType.vue?vue&type=script&lang=js"
import style0 from "./CustomBarChartQuizType.vue?vue&type=style&index=0&id=465a8714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465a8714",
  null
  
)

export default component.exports